import styled from 'styled-components';
export const Container = styled.div`
  &&.container {
    margin-bottom: 35px;
    background-color: skyblue;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .headerContainer {
    display: flex;
    justify-content: space-between;
  }
  .documentsContainer {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
  }
  .documentContainer {
    width: 200px;
    height: 100px;
    background: #f7f7f7 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #0000001a;
    border-radius: 4px;
    margin-top: 24px;
    margin: 0 5px;
    cursor: pointer;
  }
  .documentTypeContainer {
    top: 394px;
    left: 328px;
    width: 200px;
    height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
  }
  .documentType {
    padding: 8px 17px;
    color: #02194e;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    position: absolute;
  }
  .documentTitle {
    padding: 12px 12px 0px;
    color: #02194e;
    font-size: 13px;
    font-weight: 600;
    display: flex;
  }
  .iconStyle {
    position: relative;
    top: 10px;
    left: 80%;
    cursor: pointer;
  }
  .recapDocumentType {
    padding: 0px 12px;
    font-weight: normal;
    display: flex;
    position: absolute;
    font-size: 13px;
    font-family: Roboto;
    color: #999999;
  }
`;

export const Title = styled.p`
  text-align: left;
  text-transform: inherit;
  font-size: 24px;
  margin: 10px;
  font-weight: 500;
  font-family: Roboto;
  width: auto;
  color: #2b2727;
`;

export const StyledDiv = styled.div`
  height: 24px;
  text-align: left;
  font-family: Roboto;
  letter-spacing: 0;
  color: #384164;
  opacity: 1;
  font-size: 20px;
  margin-top: 50px;
  margin-bottom: 40px;
  font-weight: 100;
`;
